export enum WebhookEndpointsColumnSize {
  Url = 18,
  Description = 23,
  ListeningFor = 25,
  Status = 10,
  UpdatedAt = 24,
}
